import { Typography } from '@mui/material';
import TextareaInput from './TextareaInput';

export default function InternalNotes() {
  return (
    <div className="input-group appointment-details">
      <Typography variant="h2">Internal Notes</Typography>
      <div className="inputs">
        <div className="input-row">
          <TextareaInput
            name="internalNotes"
            label="Internal Notes"
            placeholder="Optional. Enter any notes for this appointment. These notes are just for you and your team, and can not be viewed by the client."
          />
        </div>
      </div>
    </div>
  );
}
